import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../private/shared/modules/shared.module';
import { ModuleSharedModule } from '../../modules/module-shared.module';
import { RewardModalPage } from './reward-modal.page';

@NgModule({
    declarations: [
        RewardModalPage
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        SharedModule,
        ModuleSharedModule
    ],
    exports: [
        RewardModalPage
    ]
})
export class RewardModalPageModule { }
